const recaptureSiteKey =
  process.env.REACT_APP_RECAPTURE_SITE_KEY ||
  "6LfKPhUqAAAAAENle4YHsrWaSbtvnsYB1bcyXzdO";

const geminiApiKey = process.env.GEMINI_API_KEY || "";

// Log the key being used (only show first few characters for security)
console.log(
  "Using reCAPTCHA site key:",
  recaptureSiteKey?.substring(0, 10) + "...",
);

if (geminiApiKey) {
  console.log("Using Gemini API key:", geminiApiKey.substring(0, 10) + "...");
} else {
  console.log("Gemini API key not configured");
}

export const config = {
  RECAPTURE_SITE_KEY: recaptureSiteKey,
  GEMINI_API_KEY: geminiApiKey,
};
